module.exports = __webpack_public_path__ + "img/tempus-ls.c55cd763.png";